import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { STAYS_URL_DEFAULT } from "../../content/home";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let staysCache = null;
export const useStaysUrl = () => {
  const [url, setUrl] = useState(staysCache ?? STAYS_URL_DEFAULT);
  useEffect(() => {
    if (staysCache !== null) return;
    axios.get(`${API}/site-settings`).then((r) => { staysCache = r.data.feral_stays_url || STAYS_URL_DEFAULT; setUrl(staysCache); }).catch(() => {});
  }, []);
  return url;
};

export const SmartLink = ({ to, children, ...rest }) => {
  if (/^(https?:|mailto:)/.test(to)) {
    const ext = to.startsWith("http");
    return <a href={to} target={ext ? "_blank" : undefined} rel={ext ? "noopener noreferrer" : undefined} {...rest}>{children}</a>;
  }
  if (to.startsWith("/#")) {
    const onClick = (e) => {
      const el = document.getElementById(to.slice(2));
      if (el && window.location.pathname === "/") { e.preventDefault(); el.scrollIntoView({ behavior: "smooth" }); }
      rest.onClick?.(e);
    };
    return <Link to={to} {...rest} onClick={onClick}>{children}</Link>;
  }
  return <Link to={to} {...rest}>{children}</Link>;
};

// FERAL Stays link: external when configured, otherwise a clearly marked coming-soon state.
export const StaysLink = ({ className = "", children, testid, comingClass = "" }) => {
  const url = useStaysUrl();
  if (url) return <a href={url} target="_blank" rel="noopener noreferrer" className={className} data-testid={testid}>{children}</a>;
  return (
    <span className={`${className} ${comingClass} cursor-default`} data-testid={testid} aria-disabled="true" title="FERAL Stays website coming soon">
      {children}
      <span className="feral-header inline-block whitespace-nowrap ml-2 align-middle text-[9px] leading-none tracking-[0.2em] uppercase border border-current/40 px-1.5 py-0.5 opacity-80" data-testid={`${testid}-coming-soon`}>Coming soon</span>
    </span>
  );
};

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`feral-header text-[11px] sm:text-xs font-bold tracking-[0.32em] ${className}`}>{children}</p>
);
